import { render } from "./feishuCallback.vue?vue&type=template&id=7b853a5b&scoped=true"
import script from "./feishuCallback.vue?vue&type=script&lang=js"
export * from "./feishuCallback.vue?vue&type=script&lang=js"

import "./feishuCallback.vue?vue&type=style&index=0&id=7b853a5b&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b853a5b"]])

export default __exports__